import { VStack } from "goi_common";
import React, { ReactNode } from "react";

export default function MaxWidth1200Layout({
  children,
  maxWidth = 1200,
}: {
  children: ReactNode;
  maxWidth?: number;
}) {
  return (
    <VStack width="100%" alignItems="center">
      <VStack width="100%" maxWidth={maxWidth + "px"}>
        {children}
      </VStack>
    </VStack>
  );
}
